  function updatePresaleETA() {
    let selectedVariant = theme?.product?.variant ? theme.product.variant : theme?.quickAdd?.product?.variant;
  
    document.querySelectorAll(`#presell-eta span`).forEach((variant) => {
        variant?.classList?.remove('active');
    });
    document.querySelector(`#presell-eta`)?.classList?.remove('active');
    
    if (selectedVariant?.inventory_policy === 'continue' && selectedVariant?.inventory_quantity <= 0) {
      document.querySelector(`#presell-eta span[data-id="${selectedVariant?.id}"]`)?.classList?.add('active');
      document.querySelector(`#presell-eta`)?.classList?.add('active');
    }
  }

  function updateSubscriptionAvailability() {
    let selectedVariantID = theme?.quickAdd?.product?.variant?.id;
    let addToCartSubscribe = document.querySelector('.js-add-to-cart--subscribe');
    let subscriptionButton = document.querySelector('.subscription-button');
    
    if (theme?.product?.variant?.id) {
      selectedVariantID = theme?.product?.variant?.id;
    }
    
    if ( window.VariantsWithDisabledSubscription && window.VariantsWithDisabledSubscription.includes(selectedVariantID)) {
      if (addToCartSubscribe) {
        addToCartSubscribe.dataset.availability = 'unavailable';
      }
      if (subscriptionButton) {
        subscriptionButton.style.pointerEvents = 'none';    
      }
    } else {
      if (subscriptionButton) {
        subscriptionButton.style.pointerEvents = '';      
      }
    }
  }

  if (document.querySelector('.product__info .radio-group [type="radio"]:checked')) {
    document.querySelector('.product__info .radio-group [type="radio"]:checked').click();
  } 
  
  updatePresaleETA();
  updateSubscriptionAvailability();
  setTimeout(() => {
    updatePresaleETA();
    updateSubscriptionAvailability();
  }, "1000");
  
  document.body.addEventListener('change', e => {
    updatePresaleETA();
    updateSubscriptionAvailability();
  });

  document.body.addEventListener('variantChange', e => {
    updatePresaleETA();
    updateSubscriptionAvailability();
  });
  